import { useTranslation } from 'react-i18next';

const currencyLocale = {
	EUR: 'es',
	USD: 'en',
	ARS: 'ar'
};

export const zeroDecimalCurrencies = [
	'cve',
	'gnf',
	'idr',
	'jpy',
	'kmf',
	'krw',
	'pyg',
	'rwf',
	'ugx',
	'vnd',
	'vuv',
	'xaf',
	'xof',
	'xpf'
];

export function formatPrice({
	amount,
	currency,
	fraction,
	emptyDecimals = false
}) {
	const isZDCurrency = zeroDecimalCurrencies.includes(currency?.toLowerCase());
	const price = isZDCurrency ? amount : parseInt(amount, 10) / 100;
	currency = currency ?? '';
	const isoCurrency = currency.toUpperCase();

	if (Number.isNaN(price)) {
		return '';
	}

	const language = navigator.language || currencyLocale[isoCurrency] || 'en';

	const hasDecimals = !Number.isInteger(price);

	const fractionDigits = isZDCurrency
		? 0
		: (fraction ?? (emptyDecimals || hasDecimals ? 2 : 0));

	return new Intl.NumberFormat(language, {
		style: 'currency',
		currency: isoCurrency,
		minimumFractionDigits: fractionDigits,
		maximumFractionDigits: fractionDigits
	}).format(price);
}

export function recurringDetailsText(plan) {
	const { t } = useTranslation();
	if (plan.name === 'trial') return '';
	let text = '/';
	if (plan.recurringDetails) {
		if (plan.recurringDetails.intervalCount > 1) {
			text = text.concat(`${plan.recurringDetails.intervalCount} `);
		}
		text = text.concat(t(`plans.billing.${plan.recurringDetails.interval}`));
	}
	return text;
}
